export default function GridForm({ children }) {

    return (
        <div className="formgrid grid p-fluid mt-4">
            {children}
        </div>
    )
}